export default __webpack_public_path__ + "static/media/0910930913fb77b9bc43a56505fd776a.svg";